import React, { useContext } from "react";
import { CartContext } from "../context/CartContext";
import { useNavigate } from "react-router-dom";
import "../styles/Cart.css"; // import your CSS

const Cart = () => {
  const navigate = useNavigate();
  const { cart, removeFromCart, increaseQty, decreaseQty } = useContext(CartContext);

  const total = cart.reduce(
    (sum, item) => sum + item.price * item.quantity,
    0
  );

  return (
    <div className="cart-container">
      <h1>Shopping Cart</h1>

      {cart.length === 0 ? (
        <p>Your cart is empty</p>
      ) : (
        <>
          <div className="cart-items">
            {cart.map((product) => (
              <div className="cart-item" key={product.id}>
                <img
                  className="cart-item-image"
                  src={product.thumbnail || product.images?.[0]}
                  alt={product.title}
                />

                <div className="cart-item-info">
                  <h3>{product.title}</h3>
                  <p className="cart-item-price">${product.price}</p>

                  <div className="quantity-controls">
                    <button onClick={() => decreaseQty(product.id)}>-</button>
                    <span>{product.quantity}</span>
                    <button onClick={() => increaseQty(product.id)}>+</button>
                  </div>
                </div>

                <button
                  className="remove-btn"
                  onClick={() => removeFromCart(product.id)}
                >
                  Remove
                </button>
              </div>
            ))}
          </div>

          <h2 className="cart-total">Total: ${total.toFixed(2)}</h2>

          <button className="checkout-btn" onClick={() => navigate("/checkout")}>
            Proceed to Checkout
          </button>
        </>
      )}
    </div>
  );
};

export default Cart;